import { useEffect } from 'react';

// A page calls useDarkReady() once its colours use palette tokens (see
// docs/superpowers/specs/2026-09-27-crm-new-look-design.md §3). Dark values only apply while
// a ready page is mounted. Reference-counted so overlapping mounts (route change, StrictMode)
// don't clear the flag early.
const counts = new WeakMap();

export function markDarkReady(el = document.documentElement) {
  counts.set(el, (counts.get(el) || 0) + 1);
  el.setAttribute('data-dark-ready', '');
  let released = false;
  return () => {
    if (released) return;
    released = true;
    const next = Math.max(0, (counts.get(el) || 0) - 1);
    counts.set(el, next);
    if (next === 0) el.removeAttribute('data-dark-ready');
  };
}

export default function useDarkReady() {
  useEffect(() => markDarkReady(), []);
}
